import { LOCALISE_LANGUAGE_FIELD_NAME, PARENT_FIELD } from '@pkg/config/sanity/constants';
import { WWW_AUDIENCE_FILTER } from '@pkg/config/sanity/audience';
import { modularContentBlocks } from '@pkg/modular-blocks/frontend/web-app';
import { postFields } from '~/apis/sanity/queries/partials/postFields';
const type = '_type == $type';
const locale = `${LOCALISE_LANGUAGE_FIELD_NAME} == $locale`;
const slug = 'slug.current == $slug';
const parent = `(!defined($parent) || ${PARENT_FIELD}->slug.current == $parent)`;
const grandParent = `(!defined($grandParent) || ${PARENT_FIELD}->${PARENT_FIELD}->slug.current == $grandParent)`;
const greatGrandParent = `(!defined($greatGrandParent) || ${PARENT_FIELD}->${PARENT_FIELD}->${PARENT_FIELD}->slug.current == $greatGrandParent)`;
const audience = WWW_AUDIENCE_FILTER;
export const postBySlug = groq`{
  "page": *[${type} && ${locale} && ${slug} && ${audience} && ${parent} && ${grandParent} && ${greatGrandParent}][0] {
    ${postFields},
    defined($defaultPageBlocksDocId) => {
      "defaultPageBlocks": *[_id == $defaultPageBlocksDocId][0].content[] {
        ${modularContentBlocks}
      },
    },
  },
}`;
